/**
 * "CAD — Dollar canadien"; the bare code when the runtime has no name for it. CLDR writes
 * currency names lowercase in French and Dutch, hence the capitalisation.
 */
export function currencyLabel(code, uiLocale) {
    let name;
    try {
        name = new Intl.DisplayNames([uiLocale], { type: "currency", fallback: "none" }).of(code);
    }
    catch {
        // RangeError on a malformed code: same outcome as an unknown one.
    }
    return name ? `${code} — ${name.charAt(0).toLocaleUpperCase(uiLocale)}${name.slice(1)}` : code;
}
/**
 * The symbol an amount in `code` carries for a reader in `locale`: "€" for EUR everywhere, "$" for
 * CAD in fr-CA but "CA$" in en-GB and "$CA" in fr-FR. The bare code when the runtime has no
 * symbol for it.
 */
export function currencySymbol(code, locale) {
    try {
        return (new Intl.NumberFormat(locale, { style: "currency", currency: code })
            .formatToParts(0)
            .find((part) => part.type === "currency")?.value ?? code);
    }
    catch {
        // RangeError on a malformed code: same outcome as an unknown one.
        return code;
    }
}
